import Vue from 'vue'
import scoreGradeUtils from './scoreGradeUtils'

const scoreComputeUtils = {
  /* 合并成绩（没有作业成绩则按0计算） */
  scoreMerge (
    {usualScoreScale, examScoreScale, workScoreScale, reportScoreScale, caseScoreScale, scoreExtras = [], scoreAlias = {}, displayFraction, minScore = 0, maxScore = 100},
    {scoreUsualLuru, scoreUsualZh, scoreExamLuru, scoreExamZh, scoreWorkLuru, scoreWorkZh, scoreReportLuru, scoreReportZh, scoreCaseLuru, scoreCaseZh},
    scoreGrade) {
    let result = 0
    if (usualScoreScale) {
      if (typeof scoreUsualZh !== 'number') {
        return
      }
      result += scoreUsualZh * usualScoreScale
    }
    if (examScoreScale) {
      if (typeof scoreExamZh !== 'number') {
        return
      }
      result += scoreExamZh * examScoreScale
    }
    if (workScoreScale) {
      if (typeof scoreWorkZh !== 'number') {
        return
      }
      result += scoreWorkZh * workScoreScale
    }
    if (reportScoreScale) {
      if (typeof scoreReportZh !== 'number') {
        return
      }
      result += scoreReportZh * reportScoreScale
    }
    if (caseScoreScale) {
      if (typeof scoreCaseZh !== 'number') {
        return
      }
      result += scoreCaseZh * caseScoreScale
    }
    if (usualScoreScale && scoreUsualLuru) {
      if (scoreExtras.includes(scoreUsualLuru)) {
        return {
          mergeLuru: scoreUsualLuru,
          mergeZh: minScore
        }
      }
    }
    if (examScoreScale && scoreExamLuru) {
      if (scoreExtras.includes(scoreExamLuru)) {
        return {
          mergeLuru: scoreExamLuru,
          mergeZh: minScore
        }
      }
    }
    if (workScoreScale && scoreWorkLuru) {
      if (scoreExtras.includes(scoreWorkLuru)) {
        return {
          mergeLuru: scoreWorkLuru,
          mergeZh: minScore
        }
      }
    }
    if (reportScoreScale && scoreReportLuru) {
      if (scoreExtras.includes(scoreReportLuru)) {
        return {
          mergeLuru: scoreReportLuru,
          mergeZh: minScore
        }
      }
    }
    if (caseScoreScale && scoreCaseLuru) {
      if (scoreExtras.includes(scoreCaseLuru)) {
        return {
          mergeLuru: scoreCaseLuru,
          mergeZh: minScore
        }
      }
    }
    let mergeZh = this.scoreRound(result / 100, displayFraction)
    let mergeLuru = this.convertScore({scoreAlias, minScore, maxScore}, scoreGrade, mergeZh)
    return {mergeLuru, mergeZh}
  },
  /* 分值位数处理 */
  scoreRound (scoreZh, displayFraction) {
    if (displayFraction) {
      return Math.round(scoreZh * 10) / 10
    } else {
      return Math.round(scoreZh)
    }
  },
  /* 分值转文字 */
  convertScore ({scoreAlias = {}, minScore = 0, maxScore = 100}, scoreGrade, scoreZh) {
    let scoreLuru
    if (scoreZh >= minScore && scoreZh <= maxScore) {
      const option = scoreGradeUtils.getMatchOption(scoreGrade, scoreZh)
      if (option) {
        scoreLuru = option.name
      }
    }
    if (!scoreLuru) {
      const toText = `${scoreZh}`
      scoreLuru = scoreAlias[toText] || toText
    }
    return scoreLuru
  },
  /* 文字转分值 */
  resolveScore ({scoreExtras = [], scoreAlias = {}, displayFraction, minScore = 0, maxScore = 100},
    scoreGrades = [], scoreLuru) {
    if (isNaN(scoreLuru)) {
      const option = scoreGrades.find(scoreGrade => scoreGradeUtils.getMatchOption(scoreGrade, scoreLuru))
      let scoreZh
      if (option) {
        scoreZh = option.convert
      }
      if (typeof scoreZh !== 'number') {
        if (scoreExtras.includes(scoreLuru)) {
          scoreZh = minScore
        } else {
          const alias = Object.entries(scoreAlias).find(([k, v]) => v === scoreLuru)
          if (alias) {
            scoreZh = this.scoreRound(Number(alias[0]), displayFraction)
          }
        }
      }
      return scoreZh
    } else {
      const supportDigit = scoreGrades.find(scoreGrade => !scoreGrade.options)
      if (supportDigit) {
        const rawScoreZh = Number(scoreLuru)
        if (rawScoreZh >= minScore && rawScoreZh <= maxScore) {
          const scoreZh = this.scoreRound(rawScoreZh, displayFraction)
          if (scoreZh === rawScoreZh) {
            return scoreZh
          }
        }
      }
    }
  },
  /* 美化录入文本 */
  prettyScore ({scoreAlias = {}, displayFraction}, scoreLuru, scoreZh) {
    if (scoreLuru && typeof scoreZh === 'number') {
      if (!isNaN(scoreLuru)) {
        const toText = `${this.scoreRound(scoreZh, displayFraction)}`
        scoreLuru = scoreAlias[toText] || toText
      }
    }
    return scoreLuru
  },
  /* 验证成绩数据 */
  validateScore ({usualScoreScale, examScoreScale, workScoreScale, reportScoreScale, caseScoreScale},
    electives = [], {strict, scoreThreshold} = {}) {
    return new Promise((resolve, reject) => {
      let isValid = electives.every(({scoreUsualLuru, scoreUsualZh, scoreExamLuru, scoreExamZh, scoreWorkLuru, scoreWorkZh, scoreReportLuru, scoreReportZh, scoreCaseLuru, scoreCaseZh}, index) => {
        // 创建成绩项数组
        const scaleItems = []
        if (usualScoreScale) scaleItems.push({ name: '平时成绩', luru: scoreUsualLuru, zh: scoreUsualZh })
        if (examScoreScale) scaleItems.push({ name: '考试成绩', luru: scoreExamLuru, zh: scoreExamZh })
        if (workScoreScale) scaleItems.push({ name: '作业成绩', luru: scoreWorkLuru, zh: scoreWorkZh })
        if (reportScoreScale) scaleItems.push({ name: '实践报告成绩', luru: scoreReportLuru, zh: scoreReportZh })
        if (caseScoreScale) scaleItems.push({ name: '案例分析成绩', luru: scoreCaseLuru, zh: scoreCaseZh })

        // 检查是否有填写任何成绩项
        const hasAnyScore = scaleItems.some(item => item.luru)

        // 如果没有任何成绩项填写，则允许通过
        if (!hasAnyScore) {
          return true
        }

        // 只有在strict=true时(提交时候)才检查部分未填写的情况
        if (strict) {
          // 如果有部分成绩填写，检查是否有未填写的成绩项
          const missingItems = scaleItems.filter(item => !item.luru)
          if (missingItems.length > 0) {
            reject(new Error(`第${index + 1}行${missingItems[0].name}未填写`))
            return false
          }
        }

        // 检查已填写成绩项的有效性
        for (const item of scaleItems) {
          if (item.luru && typeof item.zh !== 'number') {
            reject(new Error(`第${index + 1}行${item.name}不合法`))
            return false
          }
        }

        return true
      })
      if (!isValid) {
        return
      }
      let result = electives.map(elective => {
        return {
          id: elective.id,
          scoreUsual: elective.scoreUsualLuru,
          scoreExam: elective.scoreExamLuru,
          scoreWork: elective.scoreWorkLuru,
          scoreReport: elective.scoreReportLuru,
          scoreCase: elective.scoreCaseLuru
        }
      })
      if (strict) {
        if (typeof scoreThreshold === 'number') {
          let isConfirm = electives.some(({scoreMergeZh}) => {
            if (typeof scoreMergeZh === 'number') {
              if (scoreMergeZh < 60 && scoreMergeZh >= scoreThreshold) {
                Vue.prototype.$confirm(`有学生综合成绩在${scoreThreshold}到60分之间，是否继续提交成绩？`, '提示', {
                  confirmButtonText: '继续',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  resolve(result)
                }).catch(() => {})
                return true
              }
            }
          })
          if (isConfirm) {
            return
          }
        }
      }
      resolve(result)
    })
  }
}

export default scoreComputeUtils
